module.exports = __webpack_public_path__ + "static/media/male-avatar.f358f7f7.svg";